<template>
  <!-- <div :class="{ 'has-logo': showLogo }"> -->
  <!-- <div> -->
  <!-- <logo v-if="showLogo" :collapse="isCollapse" /> -->
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <!-- <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      > -->

    <RouterLink class="menu-collapse" to="/" exact>
      <i @click="toggleSideBar"><svg-icon icon-class="menu-operation-title" /></i>
      <span v-if="!isCollapse" class="to-dashboard">{{ $t('nav.dashboard') }}</span>
    </RouterLink>
    <el-menu
      :collapse="isCollapse"
      :text-color="variables.menuText"
      :unique-opened="true"
      :collapse-transition="false"
      :default-active="activeMenu"
      mode="vertical"
      style="padding-bottom: 180px"
    >
      <sidebar-item v-for="(route, idx) in routes" :key="idx" :item="route" :base-path="route.path" />
    </el-menu>
    <div class="logo-bts">
      <svg-icon class="logo-bts-logo" :style="{ fontSize: isCollapse ? '20px' : '60px' }" :icon-class="isCollapse ? 's-logo' : 'logo-bt'" />
    </div>
  </el-scrollbar>
  <!-- </div> -->
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters(['sidebar']),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    }
  }
}
</script>
<style lang="scss" scoped>
.to-dashboard {
  user-select: none;
  cursor: pointer;
}
.scrollbar-wrapper {
  position: relative;
  overflow: scroll;
  height: 85% !important;
}

.logo-bts {
  position: absolute;
  font-size: 60px;
  width: calc(100% - 8px);
  z-index: 1001;
  background: #ffffff;
  bottom: 0;
  padding-left: 8px;
  padding-bottom: 20px;
  text-align: center;

  .logo-bts-logo {
    margin-right: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue